/* ============================================================
 * HUB Workwell · Secção "Fisioterapia" dentro do portal do cliente
 *
 * Reaproveita a sessão que o portal já validou — o cliente não
 * pede código nenhum. Se a empresa não tiver registos de
 * fisioterapia, não aparece nada.
 *
 * Instalar:
 *   1. Guardar em src/components/SeccaoFisioPortal.jsx
 *   2. No PortalCliente.jsx, onde ficam as outras secções:
 *        import SeccaoFisioPortal from '../components/SeccaoFisioPortal';
 *        <SeccaoFisioPortal token={token} sessao={sessao} />
 *      (os nomes das variáveis do token e da sessão podem ser outros)
 * ============================================================ */

import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabase';           // <-- ajustar se o caminho for outro
import FisioGraficos from './FisioGraficos';

const ROXO = '#691FB1';
const TINTA = '#1E1A2B', TINTA2 = '#55506B', TINTA3 = '#8A85A0';
const LINHA = '#E4DEFA';   // igual à borda do portal

export default function SeccaoFisioPortal({ token, sessao }) {
  const [dados, setDados] = useState(null);
  const [aCarregar, setACarregar] = useState(true);
  const [aberto, setAberto] = useState(true);
  const [filtros, setFiltros] = useState({ ano: '', mes: '', local: '' });

  const carregar = useCallback(async f => {
    if (!token || !sessao) { setACarregar(false); return; }
    setACarregar(true);
    const { data, error } = await supabase.rpc('fisio_dados_portal', {
      p_token: token,
      p_sessao: sessao,
      p_ano: f.ano ? Number(f.ano) : null,
      p_mes: f.mes ? Number(f.mes) : null,
      p_local: f.local || null,
    });
    setACarregar(false);
    if (error) { setDados(null); return; }   // sem acesso ou sem dados: não mostra nada
    setDados(data);
  }, [token, sessao]);

  useEffect(() => { carregar(filtros); /* eslint-disable-next-line */ }, [token, sessao]);
  useEffect(() => { if (dados) carregar(filtros); /* eslint-disable-next-line */ }, [filtros]);

  if (aCarregar && !dados) return null;
  if (!dados) return null;                   // empresa sem fisioterapia

  return (
    <div style={{ background: '#fff', border: `1px solid ${LINHA}`, borderRadius: 14, padding: '20px 24px', marginBottom: 14, fontFamily: "'DM Sans',sans-serif" }}>
      <div
        onClick={() => setAberto(a => !a)}
        style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap', cursor: 'pointer', userSelect: 'none' }}
      >
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 800, color: ROXO }}>
          Fisioterapia e bem-estar no trabalho
        </h3>
        <span style={{ fontSize: 12, color: TINTA3 }}>
          {dados.kpis?.sessoes_fisio || 0} sessões · {dados.kpis?.colaboradores || 0} colaboradores
        </span>
        <span style={{ marginLeft: 'auto', color: ROXO, fontSize: 13 }}>{aberto ? '▲' : '▼'}</span>
      </div>

      {!aberto && (
        <div style={{ fontSize: 12.5, color: TINTA2, marginTop: 6 }}>
          Indicadores do programa, sempre actualizados.
        </div>
      )}

      {aberto && (
        <div style={{ marginTop: 10 }}>
          <FisioGraficos dados={dados} filtros={filtros} onFiltros={setFiltros} aCarregar={aCarregar} />
          <div style={{ fontSize: 11.5, color: TINTA3, marginTop: 12, paddingTop: 10, borderTop: `1px solid ${LINHA}` }}>
            {dados.atualizado_em
              ? `Dados actualizados em ${new Date(dados.atualizado_em).toLocaleString('pt-PT')} · `
              : ''}
            números agregados; o programa não identifica colaboradores.
          </div>
        </div>
      )}
    </div>
  );
}
